import toValidFunnelSlug from './to-valid-funnel-slug'
import validateFunnelSlug from './validate-funnel-slug'

/**
 * Returns a valid and unique slug, increments when necesarry.
 * @function
 * @param {string} slug - Preferred slug for the page
 * @param {array} usedSlugs - Array of slugs currently used
 */
export default function generateValidSlug(slug, usedSlugs) {

  // If no slug provided use page
  slug = slug || 'page'

  const validFunnelSlug = toValidFunnelSlug(slug)
  if(validateFunnelSlug(validFunnelSlug, usedSlugs)) {

    let newSlug = false
    const split = validFunnelSlug.split('-')
    const lastPart = split[split.length - 1]

    // If last part is a dash with a number, increment the number
    if(! isNaN(Number(lastPart))) {
    
      // Remove last item array
      split.pop()

      // Increment and add number
      newSlug = split.join('-') + '-' + (Number(lastPart) + 1)

    } else {
      newSlug = validFunnelSlug + '-1'       
    }

    // validate again, recursively 
    return generateValidSlug(newSlug, usedSlugs)

  // If valid return 
  } else {
    return validFunnelSlug
  }

}